<script>
    import { mapState,mapActions } from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import SliderMixin from "../../../author/pagesbuilder/mixins/SliderMixin";
    import RowsMixin from "../../../author/pagesbuilder/mixins/RowsMixin";

    export default {
        name: "CommunityPostCardsComponent",
        mixins: [
            SliderMixin,
            RowsMixin,
            AnimationsMixin
        ],
        data () {
            return {
                componentType: "community-post-cards",
                rendersWithVue: true,
                cardTypeForSectionMapping : {
                    "CommunityPosts1" : "community-posts-card1",
                    "CommunityPosts2" : "community-posts-card2",
                    "CommunityPosts3" : "community-posts-card3"
                }
            }
        },
        computed: {
            ...mapState('common',[
                'communityPosts',
                'communityPostsLoaded',
                'communityPostsLoading',
            ]),
            ...mapState([
                'serverImg'
            ]),
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: 'basicComponentTemplate',
                    cardType: this.getDefaultCardType,
                    styles: null,
                    showSlider: false,
                    rows: 1, // this is the currentPage. increments on every click of load more
                    cardsPerRow: 3, // how many cards will load on each page
                    limitAmountOfCards: true, // flag that enables pagination on cards rendering
                    cardsLoadOption: 'load-more',
                    itemVisibilitySettings: null
                }
            },
            getDefaultCardType () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;

                if (sectionState && this.cardTypeForSectionMapping[sectionTemplateId]) {
                    return this.cardTypeForSectionMapping[sectionTemplateId]
                }

                return "community-posts-card1";
            },
            availableCards () {
                return [
                    {
                        cardFilename : "community-posts-card1",
                        cardsPerRow: 3,
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/communitycard1.jpg"
                    },
                    {
                        cardFilename : "community-posts-card2",
                        cardsPerRow: 3,
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/communitycard2.jpg"
                    },
                    {
                        cardFilename : "community-posts-card3",
                        cardsPerRow: 3,
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/communitycard3.jpg"
                    },
                    {
                        cardFilename : "community-posts-card4",
                        cardsPerRow: 3,
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/communitycard4.jpg"
                    },
                    {
                        cardFilename : "community-posts-card5",
                        cardsPerRow: 3,
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/communitycard5.jpg"
                    },
                    {
                        cardFilename : "community-posts-card6",
                        cardsPerRow: 3,
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/communitycard6.jpg"
                    }
                ]
            },
            getActionTriggerComponentsData () {
                return [
                    {
                        label : this.translations.load_more,
                        display: this.renderData.data && this.renderData.data.length && (this.renderData.rows * this.renderData.cardsPerRow < this.renderData.data.length),
                        template: "load-more",
                        executableFunction : this.loadMoreClicked
                    },
                    {
                        label : this.translations.see_all,
                        display: true,
                        template: "see-all",
                        executableFunction : this.seeAllClicked
                    },
                ]
            },
            translations () {
                return {
                    "load_more" : this.$t('blog.load_more'),
                    "see_all" : this.$t('blog.see_all'),
                }
            },
            renderData () {

                if (!this.communityPosts.length && !this.communityPostsLoaded &&  !this.communityPostsLoading) {
                    this.getCommunityPosts();
                }

                let communityPosts = this.editCommunityPostsData(this.communityPosts);
                let amountOfCards = communityPosts.length;

                let cardsPerPage = (this.componentData.cardsPerRow > amountOfCards || !this.componentData.limitAmountOfCards) ? amountOfCards : this.componentData.cardsPerRow;

                let renderData = {
                    ...this.componentData,
                    data: communityPosts,
                    cardsPerRow: cardsPerPage,
                    amountOfCards,
                }


                return renderData;
            }
        },
        methods: {
            ...mapActions('common',[
                'getCommunityPosts'
            ]),
            loadMoreClicked () {},
            seeAllClicked () {},
            handleActionTrigger (componentName) {
                this.getActionTriggerComponentsData.find( data => {
                    if(data.template === componentName && data.executableFunction) {
                        data.executableFunction.call(null);
                        return true;
                    }
                })
            },
            editCommunityPostsData (communityPosts) {
                let newData = copyJson(communityPosts);

                newData.filter(communityPost => {
                    communityPost.date = LWTranslate.formatTimestampLocalized(communityPost.created, "MMMM D, YYYY");
                    communityPost.avatarImg = this.serverImg + "avatars/thumbs/" + communityPost.user_id.id + ".jpg";
                    return communityPost;
                })

                return newData;
            }
        }
    }
</script>
